// src/pages/Teto_vs_egen/Analyze/translateFeatureNames.js

export const displayNames = {
  'Face Aspect Ratio': '얼굴 세로 길이',
  'Cheek to Forehead Ratio': '광대 돌출도',
  'Jaw to Cheek Ratio': '하관 무게감',
  'Middle to Cheek Ratio': '중안부 길이',
  'Lower Face Ratio': '하안부 존재감',
  'Jaw Angle': '턱 각도',
  'Chin Sharpness': '턱끝 각도',
};

export const featureDescriptions = {
  'Face Aspect Ratio': '얼굴이 세로로 얼마나 긴지 나타냅니다. 높을수록 성숙한 느낌을, 낮을수록 동안 느낌을 줍니다.',
  'Cheek to Forehead Ratio': '얼굴 옆면에서 광대가 얼마나 입체적으로 느껴지는지 보여줍니다. 높을수록 얼굴의 실루엣이 뚜렷해집니다.',
  'Jaw to Cheek Ratio': '얼굴 아래쪽이 얼마나 묵직하게 잡혀있는지 나타냅니다. 높을수록 남성적이고 강인한 인상을 줍니다.',
  'Middle to Cheek Ratio': '얼굴 중앙(눈썹~코끝)의 시각적 비중입니다. 높을수록 이목구비가 집중되어 지적인 분위기를 풍깁니다.',
  'Lower Face Ratio': '인중부터 턱끝까지의 시각적 길이입니다. 높을수록 하관의 힘이 강조되며 뚜렷한 존재감을 줍니다.',
};

const textReplacements = {
  'Face Aspect Ratio가': '얼굴세로 비율이',
  'Face Aspect Ratio': '얼굴세로 비율',
  'Jaw to Cheek 비율이': '턱의 너비가',
  'Jaw-to-Cheek 비율이': '턱의 너비가',
  'Jaw to Cheek Ratio': '턱의 너비 길이',
  'Cheek to Forehead': '광대 너비 비율',
  'Cheek to Forehead Ratio가': '광대 너비 비율이',
  'Cheek-to-Forehead': '광대 너비 비율',
  'Middle to Cheek': '중안부 길이 비율',
  'Middle to Cheek Ratio가': '중안부 길이 비율이',
  'Middle-to-Cheek': '중안부 길이 비율',
  'Lower Face Ratio가': '하안부 길이 비율이',
  'Lower Face Ratio': '하안부 길이 비율',
};

export function translateFeatureText(text) {
  if (!text) return '';
  let translated = text;
  for (const [eng, kor] of Object.entries(textReplacements)) {
    translated = translated.replaceAll(eng, kor);
  }
  return translated;
}
